import { PostAskRequest } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemotePostAskRequest extends BaseHttpService<PostAskRequest.Model> implements PostAskRequest {
  async post(body: PostAskRequest.Body): Promise<PostAskRequest.Model> {
    return await this.request('post', body);
  }
}
